module.exports = "\n\t<router-outlet></router-outlet>\n\t<ng4-loading-spinner> </ng4-loading-spinner>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main